export default __webpack_public_path__ + "static/tpb-661f39f5a9730281a57bee474dd0b1bc.png";